/* eslint-disable @eslint-react/no-clone-element */
/* eslint-disable @eslint-react/no-children-map */
/* eslint-disable @eslint-react/no-children-count */
/* eslint-disable @eslint-react/no-children-to-array */
import type { PropsWithChildren } from 'react';
import { Children, useState, cloneElement, isValidElement } from 'react';

import { MoreButton } from '#components/base/MoreButton/MoreButton';

import styles from './ArticleSectionRelatedTeasersClamp.module.scss';

type Props = {
	threshold: number;
};

export function ArticleSectionRelatedTeasersClamp({ threshold, children }: PropsWithChildren<Props>) {
	const [isOpen, setIsOpen] = useState(false);
	const childrenCount = Children.count(children);

	if (childrenCount <= threshold) {
		return children;
	}
	const visible = Children.toArray(children).splice(0, threshold);
	const hidden = Children.toArray(children).splice(threshold);

	const moreCount = childrenCount - threshold;
	const moreButtonAriaLabel = isOpen ? 'Weniger Artikel anzeigen' : `Mehr anzeigen (${moreCount} weitere Artikel)`;

	return (
		<>
			{visible}

			{Children.map(hidden, (item) => {
				if (isOpen || !isValidElement(item)) {
					return item;
				} else {
					const className = `${typeof item.props === 'object' && item.props && 'className' in item.props ? item.props.className : ''} ${styles.hidden}`;

					// @ts-expect-error cloneElement is not typed correctly
					const r = cloneElement(item, { className });
					return r;
				}
			})}

			<MoreButton
				className={styles.showMoreButton}
				onClick={() => setIsOpen(!isOpen)}
				count={isOpen ? undefined : moreCount}
				aria-label={moreButtonAriaLabel}
			>
				{isOpen ? 'Weniger anzeigen' : 'Mehr anzeigen'}
			</MoreButton>
		</>
	);
}
